// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-login-page {
  padding-top: 7em;
}

.login-page-logo {
  float: left;
  width: 194px;
  /* margin-top: 6vh; */
}

.login-section {
  margin-top: 1em;
}

.login-section h1,
.login-section h2 {
  font-weight: 700;
}

.login-section h2 {
  font-size: 1.4em;
}

.form-login-forget a {
  color: #db0b27;
  font-weight: 700;
  text-decoration: none;
  font-size: 0.9em;
}

.form-login-register {
  text-align: center;
}

.form-login-register p {
  margin-bottom: 0;
}

.login-help-text {
  color: #6b6c6d;
  font-size: 0.9em;
  text-align: center;
}

.login-help-text-link {
  color: #6b6c6d;
  font-weight: 700;
  text-decoration: none;
}

.form-login-register a {
  font-weight: 700;
  text-decoration: none;
}

.toggle-password {
  float: right;
  margin-right: 15px;
  margin-top: -2.7em;
  position: relative;
  z-index: 2;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
}

.toggle-password img {
  max-width: 30px;
}

.form-floating > .form-control:focus + .toggle-password {
  opacity: 1;
  transition: opacity 0.3s;
}

.was-validated .form-control:valid + .toggle-password,
.form-control.is-valid + .toggle-password,
.was-validated .form-control:invalid + .toggle-password,
.form-control.is-invalid + .toggle-password {
  margin-right: 35px;
}

.go-back-link {
  color: #db0b27;
  font-weight: 800;
  font-size: 0.9rem;
}

.alert-warning-login {
  color: #d68c49;
  background-color: #fff3cd;
  border-color: #ffecb5;
  font-size: 0.9em;
  text-align: left;
}

.alert-primary-login {
  color: #3a87ad;
  background-color: #cfe2ff;
  border-color: #b6d4fe;
  font-size: 0.9em;
}

.alert-danger-login {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 0.9em;
}

.alert-success-login {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  font-size: 0.9em;
}

.warning-icon-label {
  width: 1.3em;
  margin-right: 0.5em;
  vertical-align: top;
}

.no-email {
  color: #db0b27;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
}

.verify-text-info {
  color: rgba(43, 54, 59, 0.5);
}

.verify-text-email-data {
  font-weight: 700;
  margin-top: -1em;
}

.verify-text-info-link {
  color: #db0b27;
  font-weight: 500;
  cursor: pointer;
}

.verify-modal-title {
  font-weight: 900;
  font-size: 1.3rem;
}

.form-login-btn {
  font-size: 0.9em;
}

.form-login-register {
  font-size: 0.9em;
}

.login-help-text {
  font-size: 0.9em;
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .login-page-logo {
    float: left;
    width: 194px;
    /* margin-top: 6vh; */
  }

  .content-login-page {
    padding-top: 3.06em;
  }

  .form-login-register p {
    display: inline;
    margin-right: 0.5em;
  }

  .login-container {
    margin-top: 1em !important;
  }

  .login-header-container {
    display: flex;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/login.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;AACF","sourcesContent":[".content-login-page {\n  padding-top: 7em;\n}\n\n.login-page-logo {\n  float: left;\n  width: 194px;\n  /* margin-top: 6vh; */\n}\n\n.login-section {\n  margin-top: 1em;\n}\n\n.login-section h1,\n.login-section h2 {\n  font-weight: 700;\n}\n\n.login-section h2 {\n  font-size: 1.4em;\n}\n\n.form-login-forget a {\n  color: #db0b27;\n  font-weight: 700;\n  text-decoration: none;\n  font-size: 0.9em;\n}\n\n.form-login-register {\n  text-align: center;\n}\n\n.form-login-register p {\n  margin-bottom: 0;\n}\n\n.login-help-text {\n  color: #6b6c6d;\n  font-size: 0.9em;\n  text-align: center;\n}\n\n.login-help-text-link {\n  color: #6b6c6d;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.form-login-register a {\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.toggle-password {\n  float: right;\n  margin-right: 15px;\n  margin-top: -2.7em;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.3s;\n}\n\n.toggle-password img {\n  max-width: 30px;\n}\n\n.form-floating > .form-control:focus + .toggle-password {\n  opacity: 1;\n  transition: opacity 0.3s;\n}\n\n.was-validated .form-control:valid + .toggle-password,\n.form-control.is-valid + .toggle-password,\n.was-validated .form-control:invalid + .toggle-password,\n.form-control.is-invalid + .toggle-password {\n  margin-right: 35px;\n}\n\n.go-back-link {\n  color: #db0b27;\n  font-weight: 800;\n  font-size: 0.9rem;\n}\n\n.alert-warning-login {\n  color: #d68c49;\n  background-color: #fff3cd;\n  border-color: #ffecb5;\n  font-size: 0.9em;\n  text-align: left;\n}\n\n.alert-primary-login {\n  color: #3a87ad;\n  background-color: #cfe2ff;\n  border-color: #b6d4fe;\n  font-size: 0.9em;\n}\n\n.alert-danger-login {\n  color: #a94442;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  font-size: 0.9em;\n}\n\n.alert-success-login {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-color: #d6e9c6;\n  font-size: 0.9em;\n}\n\n.warning-icon-label {\n  width: 1.3em;\n  margin-right: 0.5em;\n  vertical-align: top;\n}\n\n.no-email {\n  color: #db0b27;\n  cursor: pointer;\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.verify-text-info {\n  color: rgba(43, 54, 59, 0.5);\n}\n\n.verify-text-email-data {\n  font-weight: 700;\n  margin-top: -1em;\n}\n\n.verify-text-info-link {\n  color: #db0b27;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.verify-modal-title {\n  font-weight: 900;\n  font-size: 1.3rem;\n}\n\n.form-login-btn {\n  font-size: 0.9em;\n}\n\n.form-login-register {\n  font-size: 0.9em;\n}\n\n.login-help-text {\n  font-size: 0.9em;\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  .login-page-logo {\n    float: left;\n    width: 194px;\n    /* margin-top: 6vh; */\n  }\n\n  .content-login-page {\n    padding-top: 3.06em;\n  }\n\n  .form-login-register p {\n    display: inline;\n    margin-right: 0.5em;\n  }\n\n  .login-container {\n    margin-top: 1em !important;\n  }\n\n  .login-header-container {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
